import {
  createStore, applyMiddleware, compose, combineReducers,
} from 'redux';

// Middleware
import thunk from 'redux-thunk';
import logger from 'redux-logger';

import rootReducer from '../reducers';

const initialState = {};
let composeEnhancers = compose;

const middleware = [thunk];

/* eslint-disable no-underscore-dangle */
if (process.env.NODE_ENV === 'development') {
  middleware.push(logger);
  if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({});
  }
}
/* eslint-enable */

const enhancer = composeEnhancers(applyMiddleware(...middleware));

const store = createStore(rootReducer, initialState, enhancer);

if (module.hot) {
  // Enable Webpack hot module replacement for reducers
  module.hot.accept('../reducers', () => {
    const nextReducer = combineReducers(rootReducer);
    store.replaceReducer(nextReducer);
  });
}

export default store;
